import PageInscription from "@modules/abonnement/pages/PageInscription.vue"

// ====================================
// Module Subscription - Routes
// ====================================
export const routes = [
    {
        path: "inscription",
        name: "PageInscription",
        component: PageInscription,
        meta: {
            layout: "blank",
        },
    },
]
